import { render, staticRenderFns } from "./P-Text.vue?vue&type=template&id=84c4a2a2&lang=pug&"
import script from "./P-Text.vue?vue&type=script&lang=js&"
export * from "./P-Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports